import { BreakpointsStateInterface } from '@systemeio/util'
import { DeviceTypeEnum } from 'shared/hooks/use-metadata-from-server'

export const serverDeviceBreakpointOverrides: Record<
  DeviceTypeEnum,
  Partial<BreakpointsStateInterface>
> = {
  [DeviceTypeEnum.Desktop]: {
    isDesktop: true,
  },
  [DeviceTypeEnum.Mobile]: {
    isMobile: true,
  },
  [DeviceTypeEnum.Tablet]: {
    isTablet: true,
  },
  [DeviceTypeEnum.Unknown]: {},
}
